module.exports = __webpack_public_path__ + "static/media/Huisreglement-De-Kleine-Aapjes-2020.e0e2619c.pdf";